import React from "react";
import LegalDocument from "../components/legal/LegalDocument";

const PrivacyNotice = () => {
  return <LegalDocument type="privacy" />;
};

export default PrivacyNotice;
